import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   data: {}, isLoading: false
};

const agentWalletSlice = createSlice({
  name: "AgentWallet",
  initialState,
  reducers: {
    updateWalletBalance: (state, action) => {
    //   state.data = action.payload;
    // console.log("action",action.payload)
    state.data = action.payload;
      state.isLoading = false;
    //   state.userId = action.payload.userId;
    // return {...action.payload} 
    },
  },
});

export const { updateWalletBalance } = agentWalletSlice.actions;
export default agentWalletSlice.reducer;
